import z from 'zod';

const USA_TERRITORIES = ['US', 'PR', 'VI', 'GU', 'MP', 'AS', 'FM', 'MH', 'PW'];

export function isInternationalCountry(country) {
    return country && !USA_TERRITORIES.includes(country.toUpperCase().trim());
}

export const marshallingAddressSchema = z.object({
    marshallingVendorId: z.coerce.number().optional(),
    zone: z.string().optional(),
    state: z.string().optional(),
    location: z.coerce.number().optional(),
    deliveryOption: z.string().optional(),
    marshallingAddress: z.object({
        location: z.string().optional(),
        deliveryAddress: z.object({
            title: z.string().nullish(),
            address1: z.string().nullish(),
            address2: z.string().nullish(),
            address3: z.string().nullish(),
            city: z.string().nullish(),
            state: z.string().nullish(),
            zip: z.string().nullish(),
            country: z.string().nullish(),
        }),
        pointOfContact: z.object({
            firstName: z.string().nullish(),
            lastName: z.string().nullish(),
            email: z.string().nullish(),
            phone: z.object({
                countryCode: z.string().nullish(),
                number: z.coerce.string().nullish(),
                extension: z.string().nullish(),
            })
        }),
        telematicsInstaller: z.coerce.boolean().nullish(),
        acceptingElectricVehicles: z.coerce.boolean().nullish(),
    }),
    alternateDeliveryAddress: z.object({
        location: z.string().optional(),
        deliveryAddress: z.object({
            entityName: z.string().nullish(),
            address1: z.string().nullish(),
            address2: z.string().nullish(),
            address3: z.string().nullish(),
            city: z.string().nullish(),
            state: z.string().nullish(),
            zip: z.string().nullish(),
            country: z.string().nullish(),
        }),
        pointOfContact: z.object({
            firstName: z.string().nullish(),
            lastName: z.string().nullish(),
            email: z.string().nullish(),
            phone: z.object({
                countryCode: z.string().nullish(),
                number: z.coerce.string().nullish(),
                extension: z.string().nullish(),
            })
        }),
        telematicsInstaller: z.coerce.boolean().nullish(),
        acceptingElectricVehicles: z.coerce.boolean().nullish(),
    }),
    licenseDelivery: z.string().nullish(),
    fmcLocation: z.coerce.number().optional(),
    fieldOffice: z.string().optional(),
    fmcOfficeLocationDetails: z.object({
        location: z.string().nullish(),
        deliveryAddress: z.object({
            address1: z.string().nullish(),
            address2: z.string().nullish(),
            address3: z.string().nullish(),
            city: z.string().nullish(),
            state: z.string().nullish(),
            zip: z.string().nullish(),
            country: z.string().nullish(),
        }).optional(),
        fieldOffice: z.string().optional(),
        fieldOfficeDeliveryAddress: z.object({
            address1: z.string().nullish(),
            address2: z.string().nullish(),
            address3: z.string().nullish(),
            city: z.string().nullish(),
            state: z.string().nullish(),
            zip: z.string().nullish(),
            country: z.string().nullish(),
        }).optional(),
    }),
    licenseDeliverPoC: z.object({
        firstName: z.string().optional(),
        lastName: z.string().optional(),
        email: z.string().optional(),
        phone: z.object({
            countryCode: z.string().optional(),
            number: z.string().optional(),
            extension: z.string().optional(),
        }),
        fax: z.object({
            countryCode: z.string().optional(),
            number: z.string().optional(),
            extension: z.string().optional(),
        })
    }),
    alternateDeliverPoC: z.object({
        firstName: z.string().optional(),
        lastName: z.string().optional(),
        email: z.string().optional(),
        phone: z.object({
            countryCode: z.string().optional(),
            number: z.string().optional(),
            extension: z.string().optional(),
        }),
        fax: z.object({
            countryCode: z.string().optional(),
            number: z.string().optional(),
            extension: z.string().optional(),
        })
    })
}).superRefine((data, ctx) => {
    console.log('data', data);
    if (data.marshallingAddress.deliveryAddress.country === 'US' || data.marshallingAddress.deliveryAddress.country === 'PR') {
        if (!data.licenseDelivery && data.deliveryOption === 'marshallerDelivery') {
            ctx.addIssue({
                message: 'Please select one address',
                code: z.ZodIssueCode.custom,
                path: ['licenseDelivery']
            })
        }
        if (data.licenseDelivery === 'ship') {
            if (!data.licenseDeliverPoC.firstName) {
                ctx.addIssue({
                    message: 'First name is required',
                    code: z.ZodIssueCode.custom,
                    path: ['licenseDeliverPoC', 'firstName']
                })
            }

            if (!data.licenseDeliverPoC.lastName) {
                ctx.addIssue({
                    message: 'Last name is required',
                    code: z.ZodIssueCode.custom,
                    path: ['licenseDeliverPoC', 'lastName']
                })
            }

            if (!data.licenseDeliverPoC.email) {
                ctx.addIssue({
                    message: 'Email is required',
                    code: z.ZodIssueCode.custom,
                    path: ['licenseDeliverPoC', 'email']
                })
            } else if (!data.licenseDeliverPoC.email.match(
                // eslint-disable-next-line no-useless-escape
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            )) {
                ctx.addIssue({
                    message: 'Email must be a valid email address',
                    code: z.ZodIssueCode.custom,
                    path: ['licenseDeliverPoC', 'email']
                })
            }

            if (!data.licenseDeliverPoC.phone.countryCode) {
                ctx.addIssue({
                    message: 'Country code is required',
                    code: z.ZodIssueCode.custom,
                    path: ['licenseDeliverPoC', 'phone', 'countryCode']
                });
            }

            if (!data.licenseDeliverPoC.phone.number) {
                ctx.addIssue({
                    message: 'Phone number is required',
                    code: z.ZodIssueCode.custom,
                    path: ['licenseDeliverPoC', 'phone', 'number']
                });
            }
        }
    }
    if (data.deliveryOption === 'marshallerDelivery') {
        if (!data.location || Number(data.location) <= 0) {
            ctx.addIssue({
                message: 'Please select a marshalling location',
                code: z.ZodIssueCode.custom,
                path: ['location'],

            });
        }
        if ((!data.fmcLocation || Number(data.fmcLocation) <= 0) && data.licenseDelivery === 'ship') {
            ctx.addIssue({
                message: 'Please select a FMC location',
                code: z.ZodIssueCode.custom,
                path: ['fmcLocation'],

            });
        }
    }
    if (data.deliveryOption === 'alternateDeliveryLocation') {
        if ((!data.fmcLocation || Number(data.fmcLocation) <= 0) && (data.alternateDeliveryAddress.deliveryAddress.country === 'US' || data.alternateDeliveryAddress.deliveryAddress.country === 'PR')) {
            ctx.addIssue({
                message: 'Please select a FMC location',
                code: z.ZodIssueCode.custom,
                path: ['fmcLocation'],

            });
        }
        if (!data.alternateDeliveryAddress.pointOfContact.firstName) {
            ctx.addIssue({
                message: 'First name is required',
                code: z.ZodIssueCode.custom,

                path: ['alternateDeliveryAddress', 'pointOfContact', 'firstName']
            })
        }

        if (!data.alternateDeliveryAddress.pointOfContact.lastName) {
            ctx.addIssue({
                message: 'Last name is required',
                code: z.ZodIssueCode.custom,

                path: ['alternateDeliveryAddress', 'pointOfContact', 'lastName']
            })
        }

        if (!data.alternateDeliveryAddress.pointOfContact.email) {
            ctx.addIssue({
                message: 'Email is required',
                code: z.ZodIssueCode.custom,

                path: ['alternateDeliveryAddress', 'pointOfContact', 'email']
            })
        } else if (!data.alternateDeliveryAddress.pointOfContact.email.match(
            // eslint-disable-next-line no-useless-escape
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        )) {
            ctx.addIssue({
                message: 'Email must be a valid email address',
                code: z.ZodIssueCode.custom,

                path: ['alternateDeliveryAddress', 'pointOfContact', 'email']
            })
        }

        if (!data.alternateDeliveryAddress.pointOfContact.phone.countryCode) {
            ctx.addIssue({
                message: 'Country code is required',
                code: z.ZodIssueCode.custom,
                path: ['alternateDeliveryAddress', 'pointOfContact', 'phone', 'countryCode'],

            });
        }

        if (!data.alternateDeliveryAddress.pointOfContact.phone.number) {
            ctx.addIssue({
                message: 'Phone number is required',
                code: z.ZodIssueCode.custom,

                path: ['alternateDeliveryAddress', 'pointOfContact', 'phone', 'number']
            });
        }
        if (data?.alternateDeliveryAddress.deliveryAddress?.country && !isInternationalCountry(data?.alternateDeliveryAddress.deliveryAddress?.country)) {
            if (!data.licenseDeliverPoC.firstName) {
                ctx.addIssue({
                    message: 'First name is required',
                    code: z.ZodIssueCode.custom,

                    path: ['licenseDeliverPoC', 'firstName']
                })
            }

            if (!data.licenseDeliverPoC.lastName) {
                ctx.addIssue({
                    message: 'Last name is required',
                    code: z.ZodIssueCode.custom,

                    path: ['licenseDeliverPoC', 'lastName']
                })
            }

            if (!data.licenseDeliverPoC.email) {
                ctx.addIssue({
                    message: 'Email is required',
                    code: z.ZodIssueCode.custom,

                    path: ['licenseDeliverPoC', 'email']
                })
            } else if (!data.licenseDeliverPoC.email.match(
                // eslint-disable-next-line no-useless-escape
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            )) {
                ctx.addIssue({
                    message: 'Email must be a valid email address',
                    code: z.ZodIssueCode.custom,

                    path: ['licenseDeliverPoC', 'email']
                })
            }

            if (!data.licenseDeliverPoC.phone.countryCode) {
                ctx.addIssue({
                    message: 'Country code is required',
                    code: z.ZodIssueCode.custom,
                    path: ['licenseDeliverPoC', 'phone', 'countryCode'],

                });
            }

            if (!data.licenseDeliverPoC.phone.number) {
                ctx.addIssue({
                    message: 'Phone number is required',
                    code: z.ZodIssueCode.custom,

                    path: ['licenseDeliverPoC', 'phone', 'number']
                });
            }
        }

        if (!data?.alternateDeliveryAddress.deliveryAddress?.country || !isInternationalCountry(data?.alternateDeliveryAddress.deliveryAddress?.country) || data?.alternateDeliveryAddress.deliveryAddress?.country === 'Select Country') {
            const usZipRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;
            if (!usZipRegex.test(data?.alternateDeliveryAddress.deliveryAddress?.zip)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Please enter a valid zip code',
                    path: [`alternateDeliveryAddress`, 'deliveryAddress', 'zip'],

                });
            }
        } else {
            // International postal codes allow alphanumeric characters and common separators
            const internationalPostalRegex = /^[A-Za-z0-9\s\-]{1,12}$/;
            if (!internationalPostalRegex.test(data?.alternateDeliveryAddress.deliveryAddress?.zip)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Please enter a valid zip code',
                    path: [`alternateDeliveryAddress`, 'deliveryAddress', 'zip'],

                });
            }
        }

        if (!data?.alternateDeliveryAddress.deliveryAddress?.address1) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Please fill out the address line 1',
                path: [`alternateDeliveryAddress`, 'deliveryAddress', 'address1'],

            });
        }
        if (!data?.alternateDeliveryAddress.deliveryAddress?.city) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Please fill out the city',
                path: [`alternateDeliveryAddress`, 'deliveryAddress', 'city'],

            });
        }
        if (!data?.alternateDeliveryAddress.deliveryAddress?.state || data?.alternateDeliveryAddress.deliveryAddress?.state === '-1') {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Please fill out the state',
                path: [`alternateDeliveryAddress`, 'deliveryAddress', 'state'],

            });
        }
        if (!data?.alternateDeliveryAddress.deliveryAddress?.country) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Please fill out the country',
                path: [`alternateDeliveryAddress`, 'deliveryAddress', 'country'],

            });
        }
        if (!data?.alternateDeliveryAddress.deliveryAddress?.entityName) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Please fill out the Agency name',
                path: [`alternateDeliveryAddress`, 'deliveryAddress', 'entityName'],

            });
        }

        if (!data.alternateDeliveryAddress?.pointOfContact?.firstName) {
            ctx.addIssue({
                message: 'First name is required',
                code: z.ZodIssueCode.custom,

                path: [`alternateDeliveryAddress`, 'pointOfContact', 'firstName'],
            })
        }

        if (!data.alternateDeliveryAddress?.pointOfContact?.lastName) {
            ctx.addIssue({
                message: 'Last name is required',
                code: z.ZodIssueCode.custom,

                path: [`alternateDeliveryAddress`, 'pointOfContact', 'lastName']
            })
        }

        if (!data.alternateDeliveryAddress?.pointOfContact?.email) {
            ctx.addIssue({
                message: 'Email is required',
                code: z.ZodIssueCode.custom,

                path: [`alternateDeliveryAddress`, 'pointOfContact', 'email']
            })
        } else if (!data.alternateDeliveryAddress?.pointOfContact?.email.match(
            // eslint-disable-next-line no-useless-escape
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        )) {
            ctx.addIssue({
                message: 'Email must be a valid email address',
                code: z.ZodIssueCode.custom,

                path: [`alternateDeliveryAddress`, 'pointOfContact', 'email']
            })
        }

        if (!data.alternateDeliveryAddress?.pointOfContact?.phone.countryCode) {
            ctx.addIssue({
                message: 'Country code is required',
                code: z.ZodIssueCode.custom,
                path: [`alternateDeliveryAddress`, 'pointOfContact', 'phone', 'countryCode'],

            });
        }

        if (!data.alternateDeliveryAddress?.pointOfContact?.phone.number) {
            ctx.addIssue({
                message: 'Phone number is required',
                code: z.ZodIssueCode.custom,

                path: [`alternateDeliveryAddress`, 'pointOfContact', 'phone', 'number']
            });
        }
    }
})